import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { DirectoryType } from "./Types";

export function GoogleIcon(props: SvgIconProps) {
    return <SvgIcon {...props} viewBox="0 0 48 48">
        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </SvgIcon>;
}

export function MicrosoftIcon(props: SvgIconProps) {
    return <SvgIcon {...props} viewBox="0 0 24 24">
        <path fill="#F25022" d="M2 2h9.2v9.2H2z" />
        <path fill="#7FBA00" d="M12.8 2H22v9.2h-9.2z" />
        <path fill="#00A4EF" d="M2 12.8h9.2V22H2z" />
        <path fill="#FFB900" d="M12.8 12.8H22V22h-9.2z" />
    </SvgIcon>;
}

export function OktaIcon(props: SvgIconProps) {
    return <SvgIcon {...props} viewBox="0 0 24 24">
        <path
            fill="#007DC1"
            fillRule="evenodd"
            d="M12 2a10 10 0 100 20 10 10 0 000-20zm0 5a5 5 0 110 10 5 5 0 010-10z"
        />
    </SvgIcon>;
}

// Not a vendor logo - the Proxy Directory has no external provider behind
// it, so this is a plain, neutral "built-in" mark instead.
export function ProxyDirectoryIcon(props: SvgIconProps) {
    return <SvgIcon {...props} viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M12 2 3 6v6c0 5.25 3.6 10.14 9 11.5 5.4-1.36 9-6.25 9-11.5V6l-9-4zm0 9.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V7.3l7-3.11v7.8z"
        />
    </SvgIcon>;
}

export const directoryIcons: { [key in DirectoryType]: (props: SvgIconProps) => JSX.Element } = {
    "google": GoogleIcon,
    "azure": MicrosoftIcon,
    "okta": OktaIcon,
    "ldap": MicrosoftIcon,
    "proxy": ProxyDirectoryIcon,
};
